import { useState, useCallback } from 'react'
import { useSession } from '@clerk/clerk-react'
import { getDocument } from '../api'
import type { DocumentRecord } from '../types'

interface UseDocumentEditorReturn {
  isLoading: boolean
  initialData: DocumentRecord | null
  openEditor: (documentId?: string) => Promise<void>
}

export function useDocumentEditor(): UseDocumentEditorReturn {
  const [isLoading, setIsLoading] = useState(false)
  const [initialData, setInitialData] = useState<DocumentRecord | null>(null)
  const { session } = useSession()

  const openEditor = useCallback(
    async (documentId?: string) => {
      if (!documentId) {
        setInitialData(null)
        setIsLoading(false)
        return
      } else {
        setIsLoading(true)

        try {
          const token = await session?.getToken()
          if (!token) {
            throw new Error('No authentication token available')
          }

          const docData = await getDocument(documentId, token)
          setInitialData(docData)
        } catch (error) {
          console.error('Failed to fetch document:', error)
          setInitialData(null)
        } finally {
          setIsLoading(false)
        }
      }
    },
    [session]
  )

  return {
    isLoading,
    initialData,
    openEditor,
  }
}
